import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ConstantData } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';
@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent implements OnDestroy {

  @Input() maxDate: Date = new Date();
  mindate: Date = new Date();
  subcriptions:Subscription[] = [];
  @Input() dateChange:any;
  @Input('control') formControl: any;
  @Input() readOnly: boolean = false;
  @ViewChild('dateDiv') spandiv!: ElementRef;
  @ViewChild('inputCalender') inputCalender!: ElementRef;
  dobForm!: FormGroup;
  date: any = {
    date: 'dd',
    month: 'mm',
    year: 'yyyy'

  }
  outvalues: any = {
    month: 'mm',
    date: 'dd',
    year: 'yyyy'
  }
  constructor(private fb: FormBuilder, private util: UtilService) { }
 
  ngOnInit() {
    this.mindate.setFullYear(1950);
    this.dobForm = this.fb.group({
      dob0: ['', [Validators.required]],
      dob1: ['', [Validators.required]],
      dob2: ['', [Validators.required]]
    });
    this.subcriptions.push(this.dateChange?.subscribe((res:any)=>{
      if(!res){
        this.readOnly = false;
        const inputFields: any = document.querySelectorAll('.date-picker.custom-date input');
        inputFields.forEach((inpt:any, i:number)=>{
          if(i>2){
            return;
          }
          this.dobForm.controls['dob'+i].enable();
          // inpt.blur();
        });
        return;
      }
      this.readOnly = true;
      if(!this.formControl.value){
        const inputFields: any = document.querySelectorAll('.date-picker.custom-date input');
        inputFields.forEach((inpt:any, i:number)=>{
          if(i>2){
            return;
          }
          this.dobForm.controls['dob'+i].disable();
          // inpt.blur();
        })
        return;
      }
      const dateDob = this.formControl.value.split('/'); 
      
      const inputFields: any = document.querySelectorAll('.date-picker.custom-date input');
      dateDob.map((value: any, i: number) => {
      inputFields[i].value = value;
      this.dobForm.controls['dob'+i].disable();
      this.dateInput({ target: inputFields[i] }, inputFields[i].getAttribute('type'));
      inputFields[i].blur();
    });
  
    }));
    
    // this.formControl.valueChanges.subscribe((val:any)=>{
      
      
    // })
  }

  dateInput(event: any, type?: any) {
    const date: any = event.target;
    let value = date.value.replace(/\D/g, '');
    const inputFields: any = document.querySelectorAll('.date-picker.custom-date input');

    switch (type) {
      case this.date.date:
        {

          value = this.dateInputField(event, 'date', inputFields, 1, -1)
          if (value > 31) {
            value = 31;
          }
          this.dobForm.controls['dob0'].setValue(value);
          break;
        }
      case this.date.month:
        {

          value = this.dateInputField(event, 'month', inputFields, 2, 0);
          if (value > 12) {
            value = 12;
          }
          this.dobForm.controls['dob1'].setValue(value);

          break;
        }
      case this.date.year:
        {


          value = this.dateInputField(event, 'year', inputFields, -1, 1);
          if (this.maxDate.getFullYear() < value) {
            value = this.maxDate.getFullYear();
          }
          if (value.length === 4 && value < this.mindate.getFullYear()) {
            value = this.mindate.getFullYear();
          }
          if (this.maxDate.getFullYear() == value) {
            if (this.maxDate.getDate() < this.dobForm.value.dob0) {
              this.dobForm.controls['dob0'].setValue(this.maxDate.getDate().toString().padStart(2, '0'))
            }
            if ((this.maxDate.getMonth() + 1) < this.dobForm.value.dob1) {
              this.dobForm.controls['dob1'].setValue((this.maxDate.getMonth() + 1).toString().padStart(2, '0'))
            }

          }
          this.dobForm.controls['dob2'].setValue(value);

          break;
        }

      default:
        this.setInputFields(event);
        return;

    }

    date.value = value;
    const dateForm = Object.values(this.dobForm.value).filter((d: any) => !!(+d));
    // if (dateForm.length > 2)
      this.formControl?.setValue(dateForm.join('/'));
    // else
    //   this.formControl?.setValue('');
    (this.formControl).markAsDirty();

    this.inputCalender.nativeElement.value = this.util.formatDate(Object.values(this.dobForm.value).filter((d, i) => d).join('/'), ConstantData.candidateDobFormate);
  }
  setInputFields(event: any) {
    const inputFields: any = document.querySelectorAll('.date-picker.custom-date input');
    const date: string = this.util.formatDate(event.target.value, 'dd/MM/yyyy');
    date.split('/').map((value: any, i: number) => {
      inputFields[i].value = value;
      this.dateInput({ target: inputFields[i] }, inputFields[i].getAttribute('type'))
    });
    const dateForm = Object.values(this.dobForm.value).filter((d) => d);
    if (dateForm.length > 2)
      event.target.value = this.util.formatDate(dateForm.join('/'), ConstantData.candidateDobFormate);
    else
      event.target.value = '';
  }

  dateInputField(event: any, target: string, inputFields: any[], nextIndex: number, prevIndex: number) {
    const date: any = event.target;
    let value = date.value.replace(/\D/g, '');
    const key = event.data?.replace(/\D/g, '');
    if (value.length >= this.date[target].length && nextIndex !== -1) {
      if (key && value.length > this.date[target].length) {
        inputFields[nextIndex].value = key;
        this.dateInput({ target: inputFields[nextIndex] }, this.date[target]);
      }
      inputFields[nextIndex].focus();
    }
    if (this.date[target].length <= value.length) {
      value = value.split('').slice(0, this.date[target].length).join('');
    }
    this.outvalues[target] = this.date[target].split('').map((val: string, i: number) => value[i] ? '=' : val).join('');
    this.outvalues[target] = this.outvalues[target].split('').filter((d: any) => d === '=').length === this.date[target].length ? '' : this.outvalues[target].replaceAll('=', '&nbsp;&nbsp;');


    if (event.keyCode === 8 && prevIndex !== -1 && !value.length) {
      inputFields[prevIndex].focus();
    }

    if (event.keyCode === 191 && value.length && (this.date[target] !== this.date.year)) {
      value = value.padStart(this.date[target].length, '0');
      date.value = value;
      this.dateInput({ target: date }, this.date[target]);
      this.spandiv.nativeElement.click();
    }
    if (value.length > 1 && value === '00') {
      value = '01';
    }
    return value;
  }

  focusDate(event: any) {
    const inputs = this.spandiv.nativeElement.querySelectorAll('input');
    const inputLength = Array.from(inputs).map((v: any) => v.value).join('').length;

    if (this.readOnly) {
      inputs.forEach((ind: any) => ind.blur());
      return;
    }
    switch (inputLength) {
      case 0:
      case 1:
        inputs[0].focus();
        break;
      case 2:
      case 3:
        inputs[1].focus();
        break;
      default:
        inputs[2].focus();
        break;
    }

  }

  ngOnDestroy(): void {
    this.subcriptions.forEach((sub)=>{
      if(sub){
        sub.unsubscribe();
      }
    })
  }
}

